import axios, { AxiosRequestConfig } from "axios"

const API_URL = process.env.API_URL
// Set only at build time (Docker builder stage): build-time server calls use the API origin.
// Runtime (ISR, browsers) always uses API_URL.
const SERVER_API_URL =
  typeof window === "undefined" ? process.env.SERVER_API_URL : undefined


if (!API_URL) {
  throw new Error("Please provide the API_URL environment variable.")
}


export function getUploadURL(href: string) {
  return API_URL + href
}

const config: AxiosRequestConfig = {
  baseURL: SERVER_API_URL || API_URL,
}

const instance = axios.create(config)

export const setApiToken = (token: string) =>
  (instance.defaults.headers["Authorization"] = `Bearer ${token}`)

export const clearApiToken = () =>
  delete instance.defaults.headers["Authorization"]

export default instance

export const CancelToken = axios.CancelToken
